import type { CSSProperties } from "react";

export function Skeleton({
  className = "",
  style,
  rounded = 8,
  height = 14,
  width,
}: {
  className?: string;
  style?: CSSProperties;
  rounded?: string | number;
  height?: number | string;
  width?: number | string;
}) {
  return (
    <span
      aria-hidden
      className={`block ${className}`}
      style={{
        width,
        height,
        borderRadius: rounded,
        background:
          "linear-gradient(90deg, var(--fill-quaternary) 0%, var(--fill-tertiary) 50%, var(--fill-quaternary) 100%)",
        backgroundSize: "200% 100%",
        animation: "sqi-shimmer 1.4s ease-in-out infinite",
        ...style,
      }}
    />
  );
}
